import { formatDate } from "@memorang/helpers/date";
import type { Plan } from "@memorang/types";
import { useTranslation } from "react-i18next";
import MarkdownRenderer from "../MarkdownRenderer";
import { formatPlanDuration, getSubscriptionIntervalKey } from "./helpers";

type RecommendedPlanTextProps = {
	recommendedPlan: Plan;
	selectedDate?: string;
	isSubscriptionEnabled?: boolean;
};

const RecommendedPlanText = ({
	recommendedPlan,
	selectedDate,
	isSubscriptionEnabled,
}: RecommendedPlanTextProps) => {
	const { t, i18n } = useTranslation();

	const date = selectedDate ? formatDate(selectedDate, i18n.language) : "";

	const text = isSubscriptionEnabled
		? t(
				`purchase.paywall.recommendedPlan.subscription.${getSubscriptionIntervalKey(
					recommendedPlan.interval,
					recommendedPlan.duration,
				)}`,
				{ date },
			)
		: t("purchase.paywall.recommendedPlan.plan", {
				duration: formatPlanDuration(
					recommendedPlan.interval,
					recommendedPlan.duration,
				),
				date,
			});
	return <MarkdownRenderer text={text} textAlign="center" />;
};

export default RecommendedPlanText;
